import React, { useEffect } from 'react';

/**
 * TeamSection - Utility Benefits section with carousel
 * Exact content from original - includes team-img3.png with Limited Calls for Generation
 */
function TeamSection() {
  useEffect(() => {
    // Initialize owl carousel for team slider
    if (window.$ && window.$.fn.owlCarousel) {
      setTimeout(() => {
        window.$('#team-slider').owlCarousel({
          items: 3,
          loop: true,
          dots: true,
          nav: false,
          autoplay: true,
          autoplayTimeout: 3000,
          smartSpeed: 1500,
          responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 }
          }
        });

        // Initialize progress bars
        window.$('.progress-bar').each(function() {
          const $this = window.$(this);
          const value = $this.attr('aria-valuenow');
          $this.css('width', value + '%');
        });

        // Animate counters
        window.$('.count').each(function() {
          const $this = window.$(this);
          const countTo = $this.text();
          $this.prop('Counter', 0).animate({
            Counter: countTo
          }, {
            duration: 2000,
            easing: 'swing',
            step: function(now) {
              $this.text(Math.ceil(now));
            }
          });
        });
      }, 500);
    }
  }, []);

  return (
    <section id="team" className="bg-light">
      <div className="container">
        {/* Heading */}
        <div className="row wow fadeIn">
          <div className="col-md-12 text-center">
            <div className="title d-inline-block">
              <h6 className="mb-3">Utility Benefits</h6>
              <h2 className="gradient-text1 mb-3">
                Reduced Burden Of Generation <br />Capacity Requirements
              </h2>
              <p>
                This approach enables utilities to convert surplus generation into steady revenue, 
                reduce operational wear from plant cycling, and sell power from power pool required 
                reserve margins without new generation buildout. Designed for instant curtailment and 
                grid alignment, it supports long-term reliability planning while offering a pathway 
                to ownership—without upfront capital or operational risk.
              </p>
            </div>
          </div>
        </div>

        {/* Team Carousel */}
        <div className="row">
          <div className="col-sm-12">
            <div id="team-slider" className="owl-carousel owl-theme wow fadeInUp">
              
              {/* Team Item 1 - SPP Region Map */}
              <div className="team-box item">
                <div className="team-image">
                  <img src="images/team-img1.jpg" alt="SPP Region" />
                </div>
                <div className="team-text">
                  <h5>SPP Regional Coverage</h5>
                  <span className="alt-font">Southwest Power Pool transmission region</span>
                </div>
                {/* Progress bars hidden for cleaner display */}
              </div>

              {/* Team Item 2 - Energy Flow */}
              <div className="team-box item">
                <div className="team-image">
                  <img src="images/team-img2.jpg" alt="Energy Flow" />
                </div>
                <div className="team-text">
                  <h5>Flexible Load Integration</h5>
                  <span className="alt-font">Compute as a controllable grid resource</span>
                </div>
                {/* Progress bars hidden for cleaner display */}
              </div>

              {/* Team Item 3 - Grid Status */}
              <div className="team-box item">
                <div className="team-image">
                  <img src="images/team-img3.png" alt="Grid Status" />
                </div>
                <div className="team-text">
                  <h5>Limited Calls for Generation</h5>
                  <span className="alt-font">Marginal calls for power by the network</span>
                </div>
                {/* Progress bars hidden for cleaner display */}
              </div>

              {/* Team Item 4 - Duplicate SPP */}
              <div className="team-box item">
                <div className="team-image">
                  <img src="images/team-img1.jpg" alt="SPP Region" />
                </div>
                <div className="team-text">
                  <h5>SPP Regional Coverage</h5>
                  <span className="alt-font">Southwest Power Pool transmission region</span>
                </div>
                {/* Progress bars hidden for cleaner display */}
              </div>

              {/* Team Item 5 - Duplicate Energy Flow */}
              <div className="team-box item">
                <div className="team-image">
                  <img src="images/team-img2.jpg" alt="Energy Flow" />
                </div>
                <div className="team-text">
                  <h5>Flexible Load Integration</h5>
                  <span className="alt-font">Compute as a controllable grid resource</span>
                </div>
                {/* Progress bars hidden for cleaner display */}
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default TeamSection;